import { navigate } from "gatsby";
import React, { createContext, useState } from "react";
import {
  clearLocalStorage,
  readLocalStorage,
  writeLocalStorage,
} from "../commons/localStorageManagement";
import { useAxiosClient } from "../hooks/useAxiosClient";
import efpaConfig from "../utils/efpaConfig";
import getLoginType from "../utils/loginConfig";

export const AuthContext = createContext({
  isAuth: false,
  login: () => {},
  setStatusCode: () => {},
  statusCode: 200,
  setUserInfo: () => {},
  userInfo: {},
  logout: () => {},
  setToken: () => {},
  token: "",
  path: "",
  setPath: () => {},
  setLoginType: () => {},
  goToLogin: () => {},
  getRootToken: async () => {},
});

const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(!!readLocalStorage("isAuth", false));
  const [userInfo, setUserInfo] = useState(() =>
    JSON.parse(readLocalStorage("user", "{}"))
  );
  const [token, setToken] = useState(readLocalStorage("token", ""));
  const [savedLoginType, setSavedLoginType] = useState(
    readLocalStorage("loginType", "test")
  );
  const [statusCode, setStatusCode] = useState(200);
  const [path, setPath] = useState(readLocalStorage("path"));

  const [, triggerRequest] = useAxiosClient({}, { manual: true });

  const goToLogin = ({ prevPath = "" }) => {
    if (typeof window !== `undefined`) {
      const loginType = getLoginType();
      if (prevPath) handleSetPath(prevPath);
      navigate(`${loginType.home}login`);
    }
  };

  const handleLogin = (isLogin) => {
    setIsAuth(isLogin);
    writeLocalStorage("isAuth", isLogin);
  };

  const handleUserInfo = (info) => {
    setUserInfo(info);
    writeLocalStorage("user", JSON.stringify(info), {});
  };
  const saveLoginType = () => {
    const newLoginType = getLoginType();
    setSavedLoginType(newLoginType.name);
    writeLocalStorage("loginType", newLoginType.name, "");
  };

  const handleLogout = () => {
    handleLogin(false);
    handleUserInfo({});
    handleSetToken("");
    handleSetSetStatusCode(200);
    // setPath('/');
    saveLoginType();
    clearLocalStorage();
  };

  const handleSetToken = (userToken) => {
    setToken(userToken);
    writeLocalStorage("token", userToken);
  };

  const handleSetSetStatusCode = (status) => {
    if (status) setStatusCode(status);
  };

  const handleSetPath = (pathName) => {
    if (pathName) {
      setPath(pathName);
      writeLocalStorage("path", pathName);
    }
  };

  const getRootToken = async () => {
    const rootToken = await triggerRequest({
      baseURL: efpaConfig.PROXY_URL, 
      url: "/token/",
      method: "POST",
    }).then(({ data }) => data.access);

    return rootToken;
  };

  return (
    <AuthContext.Provider
      value={{
        login: handleLogin,
        isAuth,
        setUserInfo: handleUserInfo,
        saveLoginType,
        userInfo: userInfo,
        logout: handleLogout,
        setToken: handleSetToken,
        token,
        statusCode,
        setStatusCode: handleSetSetStatusCode,
        path,
        setPath: handleSetPath,
        savedLoginType,
        getRootToken,
        goToLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
